import { render } from "./FaqArea.vue?vue&type=template&id=746f4460"
import script from "./FaqArea.vue?vue&type=script&lang=js"
export * from "./FaqArea.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__